import React,{useEffect, useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import { useAuth } from '../../context/auth';
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast';
import {Table,Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { FaSave  } from "react-icons/fa";
import { SERVER_API } from '../../fileWithConstants';
import AddDeleteTableRows from './AddDeleteTableRows';
import { stringify } from 'uuid';
const Addpo = () => {
    const[auth, setAuth] =useAuth();
    const[userId, setUserId]=useState(auth.user.id);
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [supplier, setSupplier] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [singleSelections, setSingleSelections] = useState([]);
    const [poDate, setPoDate] = useState(new Date());
    const [delDate, setDelDate] = useState(new Date());
    const [po_number, setPo_number] = useState('');
    const [rowlist, setRowlist] = useState([]);
    const [supplierId, setSupplierId] = useState("");
    const [fabrics, setFabrics] = useState([]);
    const [pomainData, setPomainData] = useState([]);
    const [InstructedBY, setInstructedBY] = useState('');
    const [validated, setValidated] = useState(false);
    const getAllSupplier = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
          if(data?.success && data?.suppliers?.length>0){
            setSupplier(data?.suppliers)
          }
        } catch (error) {
          console.log(error)
        }
    }

    const getPoNo = async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-po-no`);
            console.log(data);
            setPo_number(`PO-${data.po_no}`);
            // setPoNumber
        } catch (error) {
            console.log(error)
        }
    }

    const getSupplierAllFabrics = async()=>{
        try {
          const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-supplier-fabrics/${supplierId}`);
          if(data?.success && data?.fabrics?.length>0){
            setFabrics(data?.fabrics)
          }
        } catch (error) {
          console.log(error)
        }
    }

    useEffect(()=>{
        getAllSupplier();
        getPoNo();
    },[])

   
    useEffect(()=>{
        if(supplierId>0){
            getSupplierAllFabrics();
        }
    },[supplierId])

    const handleSubmit = async(e)=>{
        e.preventDefault();
        const form = e.currentTarget;
        if(form.checkValidity()===false){
            e.stopPropagation();
        }
        setValidated(true);
    if(form.checkValidity()===true && !submitting && supplierId!=='') {
        try {
            const formData = new FormData();
           
           /* console.log(formData)
            console.log(rowlist)
            console.log(pomainData)   
            */
            formData.append("supplierId", supplierId);    
            formData.append("date", poDate);    
            formData.append("delDate", delDate);    
            formData.append("po_number", po_number);
            formData.append("user_id",userId);
            formData.append("instructed_by",InstructedBY);

            formData.append("pomainData", JSON.stringify(pomainData));
            formData.append("row_data", JSON.stringify(rowlist));
            //const {data} = await axios.post(`${SERVER_API}/api/v1/supplier/add-po-data`,{formData});

            const {data} = await axios.post(`${SERVER_API}/api/v1/supplier/add-po-data`,formData,{
                headers:{'Content-Type': 'application/json'}
              });
              //console.log(data)
            if(data?.success){
                toast.success(data.message);
                navigate('/dashboard/po-list')
            }

            } catch (error) {
                console.log(error)
            } finally {
                setSubmitting(false);
            }
        }
    }

    useEffect(()=>{
        if(singleSelections.length>0){
            if(supplierId!==singleSelections?.[0]['v_id']){
                setRowlist('');
            }
            setSupplierId(singleSelections?.[0]['v_id']);
        }
    });


    const handleRowdata = values => {
        //alert(JSON.stringify(values) );
        //do something with the values  
        //console.log(values)
        setRowlist(values);
     }

     const handlePodata = (podata) =>{
        //console.log(data)
        setPomainData(podata);
     }

    const handleTypeaheadChange = (selected) => {
    setSingleSelections(selected);
    if (selected.length > 0) {
      setSupplierId(selected[0]['v_id']); // adjust this depending on your object key
    } else {
      setSupplierId('');
    }
  };

     const cancelHandle = ()=>{
        navigate('/dashboard/po-list');
      }

  return (
    <Layout title={'Add Purchase Order'}>
        <div className='container form-container--'>
            <Form noValidate validated={validated} onSubmit={handleSubmit} className='form-section'>
                <h4 className='title'>New Purchase Order</h4>
                    <div className='form-box'>
                    <div className="row justify-content-center">
                    <div className='col-md-12 custom-inline-form'>
                        <div className="form-box big-box">
                        <label className="form-label">Vendor*</label>
                        <Typeahead
                            inputProps={{ required: true }}
                            name="supplier_id"
                            id="basic-typeahead-single"
                            labelKey="code"
                            onChange={handleTypeaheadChange}
                            options={supplier}
                            placeholder="Choose a supplier"
                            selected={singleSelections}
                        />
                        </div>

                        <div className="form-box date-box">
                            <label className="form-label">PO Date*</label>
                            <DatePicker
                            required
                            name='date'
                            className='form-control'
                            dateFormat="dd-MM-yyyy"
                            selected={poDate}
                            onChange={(date) => setPoDate(date)}
                            selectsStart
                            startDate={poDate}
                            endDate={delDate}
                            />
                        </div>

                        <div className="form-box date-box">
                            <label className="form-label">Delivery Date*</label>
                            <DatePicker
                            required
                            name='del_dt'
                            className='form-control'
                            dateFormat="dd-MM-yyyy"
                            selected={delDate}
                            onChange={(date) => setDelDate(date)}
                            selectsEnd
                            startDate={poDate}
                            endDate={delDate}
                            minDate={poDate}
                            />
                        </div>

                        <div className="form-box small-box">
                            <label className="form-label">Po Number*</label>
                            <Form.Control required type='text' name="po_number" className='form-control' value={po_number} readOnly/>
                        </div>
                        
                        <div className="form-box">
                            <label className="form-label">Instructed By*</label>
                            <select required className='form-control' name="instructed_by" onChange={(e)=>(setInstructedBY(e.target.value) )}>
                                <option value={""}>--Select--</option>
                                <option value={1}>Ketan Sethi</option>
                                <option value={2}>Maansi Sethi</option>
                            </select>
                        </div>
                    </div>                    
                    </div>
                    
                    
                        <AddDeleteTableRows fabrics={fabrics} handleRowdata={handleRowdata} handlePodata={handlePodata} supplierId={supplierId}/>
                    
                    
                    <div className='row submit-box'>
                        <div className='col-12'>
                            <button type="submit" className="btn btn-success">{/*<FaSave/>*/}Submit for Approval</button>
                            <button type="button" onClick={cancelHandle} className="btn btn-danger">Cancel</button>
                        </div>
                    </div>

                    
                </div>      
            </Form>
        </div>
    </Layout>
  )
}

export default Addpo
